export default function useGlobalMessages(sendSocketMessage: any) {
  const seedRequest = () => sendSocketMessage('pf')
  const newSeedRequest = (seed: string) => sendSocketMessage('pf', { clientseed: seed })
  const requestBetReply = (id: string) => sendSocketMessage('bet_reply', id)
  const settingsPost = (settings: any) => sendSocketMessage('settings', settings)
  return { seedRequest, newSeedRequest, requestBetReply, settingsPost }
}
